<template>
    <div aria-hidden="true" id="version-info" :class="toggled ? 'open' : 'closed'">
        <div v-if="toggled">
            <span class="btn btn-toggle" v-on:click="toggled = false">&times;</span>
            <strong>Version:</strong> <span class="version">{{ version }}</span><br />
            <emoji-code type="tiny"/>
        </div>
        <div v-else>
            <span class="btn btn-toggle" v-on:click="toggled = true">+</span>
        </div>
    </div>
</template>
<script>
    import AppConfig from '@/app-config'
    import {mapGetters} from 'vuex'
    import EmojiCode from "../emoji-code/index";

    export default {
        name: 'version-info',
        components: {EmojiCode},
        data() {
            return {
                toggled: false
            }
        },
        computed: {
            ...mapGetters({
                navigationGuardEnabled: 'getNavigationGuardEnabled',
                gameType: 'getGameType'
            }),
            isDev() {
                return AppConfig.isDev
            },
            version() {
                return AppConfig.versionRaw
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/variables.less";

    #version-info {
        position: fixed;
        bottom: 0;
        left: 0;
        opacity: .5;
        transition: opacity 200ms ease-in-out, width 200ms ease-in-out, height 200ms ease-in-out;
        -webkit-transition: opacity 200ms ease-in-out, width 200ms ease-in-out, height 200ms ease-in-out;
        -moz-transition: opacity 200ms ease-in-out, width 200ms ease-in-out, height 200ms ease-in-out;
        -o-transition: opacity 200ms ease-in-out, width 200ms ease-in-out, height 200ms ease-in-out;
        font-size: 12px;
        font-family: monospace;
        border-radius: 0 5px 0 0;
        background: #333333;
        color: white;
        padding: 10px;
        overflow: hidden;

        &.open {
            padding-right: 30px;
        }

        &:hover {
            opacity: 1;
        }
    }

    .btn-toggle {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        padding: 2px 5px;
        font-size: 12px;
        font-family: monospace;
        color: white;
    }

    .toggle-box {
        padding: 10px;
    }
</style>